import { render, staticRenderFns } from "./CustomSelect.vue?vue&type=template&id=456e3648&scoped=true&"
import script from "./CustomSelect.vue?vue&type=script&async=true&lang=js&"
export * from "./CustomSelect.vue?vue&type=script&async=true&lang=js&"
import style0 from "./CustomSelect.vue?vue&type=style&index=0&id=456e3648&lang=scss&scoped=true&"
import style1 from "./CustomSelect.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456e3648",
  null
  
)

export default component.exports